export const colors = [
  {
    name: 'Main expenses',
    value: '#FED057',
  },
  {
    name: 'Products',
    value: '#FFD8D0',
  },
  {
    name: 'Car',
    value: '#C5BAFF',
  },
  {
    name: 'Self care',
    value: '#6E78E8',
  },
  {
    name: 'Child care',
    value: '#4A56E2',
  },
  {
    name: 'Household products',
    value: '#81E1FF',
  },
  {
    name: 'Education',
    value: '#24CCA7',
  },
  {
    name: 'Leisure',
    value: '#00AD84',
  },
  {
    name: 'Entertainment',
    value: '#ff55ff',
  },
  {
    name: 'Other expenses',
    value: '#912c62',
  },
];
